import { CheckoutResponseDto } from '@@@/dto/api/CheckOutResponseDto';
import { CheckoutFormData } from '@@@/dto/CheckoutFormData';
import { PlanData } from '@@@/dto/PlanData';
import axios from 'axios';

const API_BASE = import.meta.env.VITE_API_BASE_URL as string

export default class CheckoutApiService {
    static async checkout(payload: { checkoutFormData: CheckoutFormData; planData: PlanData }): Promise<CheckoutResponseDto> {
        const url = `${API_BASE}/checkout`

        const response = await axios.post(url, payload);
        return response.data;
    }
}